<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <el-tabs
                    v-model="editableTabsValue"
                    type="card"
                    @edit="handleTabsEdit"
                >
                    <el-tab-pane label="餐补等级" name="1">
                        <!--查询条件-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <i class="searchDomw" @click="showSearch = !showSearch" :class="showSearch==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                                <!-- <el-button
                                    style="
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    "
                                    type="text"
                                    @click="Reset"
                                >
                                    <i class="el-icon-refresh"></i>
                                    刷新页面
                                </el-button> -->
                            </div>
                            <el-form :model="form" class="searchTjContent" v-show="showSearch">
                                <div
                                    class="searchTjContentDiv"
                                >
                                    <span class="searchTjContentDivSpan"
                                        >等级名称</span
                                    >
                                    <el-input
                                        v-model="form.gradeName"
                                        placeholder="请输入"
                                        class="searchTjContentDivInput"
                                    ></el-input>
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="quanbu"
                                >
                                    <el-button
                                        type="primary"
                                        @click="query"
                                        icon="el-icon-search"
                                        class="searchBtns"
                                        >查询</el-button
                                    >
                                </div>

                                <div
                                    class="searchTjContentDiv"
                                >
                                    <el-button
                                        type="info"
                                        @click="resert"
                                        icon="el-icon-delete"
                                        
                                        >清除条件</el-button
                                    >
                                </div>
                                <!-- <div class="arrowDown" @click="showSearch">
                                    <i
                                        class="el-icon-arrow-down"
                                        style="color: #000"
                                    ></i>
                                </div> -->
                            </el-form>
                        </div>

                        <!--按钮-->
                        <div class="searchButtonDiv" v-if="quanbu">
                            <div class="searchButtonDivLeft">
                                <el-button-group>
                                    <el-button
                                        icon="el-icon-plus"
                                        type="success"
                                        class="openBtns"
                                        @click="showDialog('新增')"
                                        >新增</el-button
                                    >
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        @click="batchDelete"
                                        >批量删除</el-button
                                    >
                                </el-button-group>
                            </div>
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        class="dropRests"
                                        @click="resertTable"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-s-grid el-icon--right"
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <template>
                                                        <el-checkbox-group
                                                            v-model="checkList"
                                                            :min="1"
                                                            text-color="#000000"
                                                            @change="tableShow"
                                                        >
                                                            <el-checkbox
                                                                label="序号"
                                                                >序号</el-checkbox
                                                            ><br />
                                                            <el-checkbox
                                                                label="等级名称"
                                                                >等级名称</el-checkbox
                                                            ><br />
                                                            <el-checkbox
                                                                label="补贴金额"
                                                                >补贴金额</el-checkbox
                                                            ><br />
                                                            <!-- <el-checkbox label="是否节假日可用"
                                  >是否节假日可用</el-checkbox
                                ><br /> -->
                                                            <el-checkbox
                                                                label="添加人"
                                                                >添加人</el-checkbox
                                                            ><br />
                                                            <el-checkbox
                                                                label="添加时间"
                                                                >添加时间</el-checkbox
                                                            ><br />
                                                            <el-checkbox
                                                                label="操作"
                                                                >操作</el-checkbox
                                                            ><br />
                                                        </el-checkbox-group>
                                                    </template>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>

                        <!--表格-->
                        <div>
                            <el-table
                                ref="multipleTable"
                                :data="myData"
                                tooltip-effect="dark"
                                @row-click="openDetails"
                                highlight-current-row
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    type="selection"
                                    width="50"
                                    align="center"
                                    @selection-change="handleSelectionChange"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    header-align="center"
                                    align="center"
                                    v-if="no1"
                                ></el-table-column>
                                <el-table-column
                                    prop="gradeName"
                                    label="等级名称"
                                    align="center"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="subsidyAmount"
                                    label="补贴金额"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no3"
                                >
                                </el-table-column>
                                <!-- <el-table-column
                  prop="isEnable"
                  label="是否节假日可用"
                  align="center"
                  show-overflow-tooltip
                  v-if="no4"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.isEnable == 0">不可用</span>
                    <span v-if="scope.row.isEnable == 1">可用</span>
                  </template>
                </el-table-column> -->
                                <!-- <el-table-column
                  prop="date4"
                  label="每人每次可用次数"
                  align="center"
                  show-overflow-tooltip
                  v-if="no5"
                >
                </el-table-column> -->
                                <el-table-column
                                    prop="createPersonName"
                                    label="添加人"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no6"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createDate"
                                    label="添加时间"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no7"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="operation"
                                    label="操作"
                                    align="center"
                                    width="280"
                                    v-if="no8"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-chakan tabBtn"
                                                @click="
                                                    showDialog(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="
                                                    showDialog(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="deleteItem(scope.row)"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog
            :title="dialogTile"
            :visible.sync="visVisible"
            width="990px"
            @close="dialogVisibleClone"
        >
            <el-form
                ref="addform"
                :model="addform"
                :rules="addformRules"
                label-width="140px"
                size="mini"
            >
                <!-- <el-form-item label="补贴方式：" prop="subsidyWay" > -->
                <el-form-item label="补贴方式：" prop="isEnable">
                    <el-radio-group v-model="addform.isEnable" @change="btfsbh">
                        <el-radio label="0" :disabled="dialogTile == '查看'"
                            >按月</el-radio
                        >
                        <el-radio label="1" :disabled="dialogTile == '查看'"
                            >按次</el-radio
                        >
                    </el-radio-group>
                    <!-- <el-radio
            :disabled="dialogTile == '查看'"
              v-model="addform.isEnable"
              label="0"
              >按月</el-radio
            >
            <el-radio
            :disabled="dialogTile == '查看'"
              v-model="addform.isEnable"
              label="1"
              >按次</el-radio
            > -->
                </el-form-item>
                <el-form-item label="等级名称：" prop="gradeName">
                    <el-input
                        :disabled="dialogTile == '查看'"
                        v-model="addform.gradeName"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="补贴金额：" prop="subsidyAmount">
                    <el-input
                        :disabled="dialogTile == '查看'"
                        v-model="addform.subsidyAmount"
                        placeholder="请输入"
                        @input="btjexg"
                    ></el-input>
                </el-form-item>
                <template v-if="addform.isEnable == 1">
                    <el-form-item label="补贴次数" prop="enableNum">
                        <el-input
                            :disabled="dialogTile == '查看'"
                            v-model="addform.enableNum"
                            size="small"
                            width="100%"
                            placeholder="请输入补贴次数"
                            @input="btcsxg"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="每次补贴金额" prop="enableAmount">
                        <el-input
                            disabled
                            v-model="addform.enableAmount"
                            size="small"
                            width="100%"
                            placeholder="获取每次补贴金额"
                        ></el-input>
                    </el-form-item>
                </template>
                <!-- <el-form-item label="是否节假日可用:" prop="isEnable">
          <el-radio
            v-model="addform.isEnable"
            label="0"
            :disabled="dialogTile == '查看'"
            >不可用</el-radio
          >
          <el-radio
            v-model="addform.isEnable"
            label="1"
            :disabled="dialogTile == '查看'"
            >可用</el-radio
          >
        </el-form-item> -->
                <!-- <el-form-item
          label="每人每次可用次数："
          prop="enableNum"
          v-if="dialogTile == '查看'"
        >
          <el-input
            :disabled="dialogTile == '查看'"
            v-model="addform.enableNum"
            placeholder="请输入"
          ></el-input>
        </el-form-item> -->
                <el-form-item
                    label="添加人："
                    v-if="dialogTile == '查看'"
                    prop="createPersonName"
                >
                    <el-input
                        :disabled="dialogTile == '查看'"
                        v-model="addform.createPersonName"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="添加时间："
                    v-if="dialogTile == '查看'"
                    prop="createDate"
                >
                    <el-date-picker
                        :disabled="dialogTile == '查看'"
                        v-model="addform.createDate"
                        type="datetime"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" v-if="dialogTile != '查看'">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="clearadddata"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import { conflictMediationApi2 } from "@/api/http.js"
import request2 from "@/utils/request2.js"
import { post, get } from "@/api/requrestHttp.js"

export default {
    data() {
        return {
            // 表单验证
            addformRules: {
                gradeName: [
                    {
                        required: true,
                        message: "请输入等级名称",
                        trigger: "blur",
                    },
                ],
                subsidyAmount: [
                    {
                        required: true,
                        message: "请输入补贴金额",
                        trigger: "blur",
                    },
                ],
                // isEnable: [
                //   { required: true, message: "请选择是否节假日可用", trigger: "change" },
                // ],
            },
            selectedData: [],
            // 图片地址
            actionUrl: "",
            visVisible: false,
            // 图片
            photo: [],
            addform: {
                photo: [],
                enableNum: "",
                enableAmount: "",
            },
            checkList: [
                "序号",
                "等级名称",
                "补贴金额",
                // "是否节假日可用",
                "添加人",
                "添加时间",
                "操作",
            ],
            quanbu: true,

            currentPage: 1, //默认展示第一页
            total: 0, //总数据
            timer: "", //定义一个定时器的变量
            showSearch: true,
            editableTabsValue: "1",
            myData: [
                {
                    gradeName: "",
                    subsidyAmount: "",
                    isEnable: "",
                    gradeName: "",
                    createPersonName: "",
                    createDate: "",
                },
            ],
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            form: {
                gradeName: "",
                pageNo: 1,
                pageSize: 10,
            },
            dialogTile: "",
            dialogImageUrl: "",
            dialogVisible1: false,
            // 列表显示
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,
            no8: true,
        }
    },
    inject: ["reload"], //注入
    methods: {
        dialogVisibleClone() {
            this.addform.enableNum = ""
            this.addform.enableAmount = ""
            delete this.addform.id
        },
        btfsbh() {
            console.log(1)
            this.addform.enableNum = ""
            this.addform.enableAmount = ""
        },
        // 列表项显示
        tableShow() {
            if (this.checkList.length > 0) {
                if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
                    this.no1 = false
                } else {
                    this.no1 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "等级名称") == -1
                ) {
                    this.no2 = false
                } else {
                    this.no2 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "补贴金额") == -1
                ) {
                    this.no3 = false
                } else {
                    this.no3 = true
                }
                // if (this.checkList.findIndex((obj) => obj == "是否节假日可用") == -1) {
                //   this.no4 = false;
                // } else {
                //   this.no4 = true;
                // }
                // if (
                //   this.checkList.findIndex((obj) => obj == "每人每次可用次数") == -1
                // ) {
                //   this.no5 = false;
                // } else {
                //   this.no5 = true;
                // }
                if (this.checkList.findIndex((obj) => obj == "添加人") == -1) {
                    this.no6 = false
                } else {
                    this.no6 = true
                }
                if (
                    this.checkList.findIndex((obj) => obj == "添加时间") == -1
                ) {
                    this.no7 = false
                } else {
                    this.no7 = true
                }
                if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
                    this.no8 = false
                } else {
                    this.no8 = true
                }
            }
        },
        // 新增
        showDialog(type, data) {
            this.visVisible = true
            this.dialogTile = type
            this.resetForm("addform")
            console.log(type)
            switch (type) {
                case "新增":
                    break
                case "查看":
                    this.look(data)
                    break
                case "编辑":
                    this.look(data)
                    break
            }
        },
        clearadddata() {
            this.visVisible = false
        },
        // 保存
        saveadddata() {
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    let params = {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        createId: this.$store.state.info.id,
                        createPersonName: this.$store.state.info.name,
                        ...this.addform,
                        qujiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .qujiId,
                        shengjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shengjiId,
                        shijiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .shijiId,
                        stationId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).stationId,
                        shequjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shequjiId,
                    }
                    params = Object.assign({}, params)
                    request({
                        url: "/sqyl/admin/subsidyLevel/info/insert",
                        method: "POST",
                        data: params,
                    }).then((res) => {
                        if (res.code == 200) {
                            this.visVisible = false
                            this.showlist()
                        }
                    })
                }
            })
        },
        // 删除
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/sqyl/admin/subsidyLevel/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        this.showlist()
                    }
                })
            })
        },
        // 查看
        look(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/sqyl/admin/subsidyLevel/info/findById",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.addform = res.content
            })
        },

        // 行点击选中
        openDetails(row, event, column, cell) {
            this.$refs.multipleTable.toggleRowSelection(row)
            this.showtext = !this.showtext
            this.row = row
            this.column = column
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },

        //每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.showlist()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.showlist()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath)
        },
        handleTabsEdit(targetName, action) {
            this.showlist(e)
        },
        //拿到列表数据
        async showlist(e) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params, {
                ...e,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            })
            await request({
                url: "/sqyl/admin/subsidyLevel/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                this.pageConfig.total = res.content.count
                this.myData = res.content.list
                this.total = res.content.count
            })
        },

        // 查询
        query() {
            post("/sqyl/admin/subsidyLevel/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
                ...this.form,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                console.log(res)
                if (res.content != null) {
                    this.myData = res.content.list
                    this.total = res.content.count
                } else {
                    this.myData = []
                }
            })
        },

        handleSelectionChange(data) {
            this.selectedData = data
        },
        batchDelete() {
            var that = this
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/sqyl/admin/subsidyLevel/info/deleteById",
                                method: "POST",
                                data: { id: item.id },
                            })
                        })
                    })
                    .then(() => {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },

        // 查询重置
        resert() {
            this.form = []
            this.showlist()
        },

        // 重置
        Reset() {
            this.reload()
        },
        btjexg() {
            // console.log(this.addform.subsidyAmount,this.addform.btcs)
            // this.addform.mcbtje = Number(this.addform.subsidyAmount)/Number(this.addform.btcs)
            let c =
                Number(this.addform.subsidyAmount) /
                Number(this.addform.enableNum)
            this.addform.enableAmount = c.toFixed(2)
        },
        btcsxg() {
            // this.addform.mcbtje = Number(this.addform.subsidyAmount)/Number(this.addform.btcs)
            // console.log(this.addform.subsidyAmount,this.addform.btcs)
            let c =
                Number(this.addform.subsidyAmount) /
                Number(this.addform.enableNum)
            this.addform.enableAmount = c.toFixed(2)
        },

        // 表单刷新
        resertTable() {
            this.showlist()
            this.checkList = [
                "序号",
                "等级名称",
                "补贴金额",
                // "是否节假日可用",
                "添加人",
                "添加时间",
                "操作",
            ]
            this.tableShow()
        },

        // 预览图片
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },

        // handleSelectionChange(data) {
        //     this.selectedData = data
        // },
        // batchDelete() {
        //     var that = this
        //     var val = this.selectedData
        //     if (val.length > 0) {
        //         this.$confirm("确认永久删除吗?", "提示", {
        //             confirmButtonText: "确定",
        //             cancelButtonText: "取消",
        //             type: "warning",
        //         })
        //             .then(() => {
        //                 val.forEach(function (item, index) {
        //                     request({
        //                         url: "/sqyl/admin/subsidyLevel/info/deleteById",
        //                         method: "POST",
        //                         data: { id: item.id },
        //                     })
        //                 })
        //             })
        //             .then(() => {
        //                 this.showlist()
        //                 this.$message({
        //                     type: "success",
        //                     message: "删除成功!",
        //                 })
        //             })
        //     } else {
        //         this.$confirm("请选择要删除的项。", "提示")
        //     }
        //     this.$refs.multipleTable.clearSelection()
        // },

        // 表单重置
        resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields()
            }
        },
    },
    created() {
        this.showlist()
    },
}
</script>
<style lang="less" scoped>
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 254px);
    background-color: #ffffff;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.rkldRightHeadRightRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    cursor: pointer;
    background: rgba(252, 254, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 19px;
    box-sizing: border-box;
    padding: 7px 20px;
    margin-left: 20px;
    color: #444;
    font-size: 12px;
}

.rkldRightHeadRightRight span {
    width: 1px;
    height: 20px;
    margin: 0 14px;
    background: #ccc;
    opacity: 0.6;
}

.rkldRightHeadRightRight div {
    display: flex;
    align-items: center;
}
.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  margin:5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;

    .el-button {
        border-radius: 4px;
    }
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}

/deep/ .el-button {
    margin-left: 0px;
    border-radius: 0px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
.searchButtonDivLeft {
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #000000;
    }

    /deep/.el-button:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    /deep/.el-button:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        i,
        span {
            color: #fff;
        }
    }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}
/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

/deep/ .el-dialog .el-dialog__header {
    border-bottom: 1px solid #e4e4e4;
}
// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}
</style>
